






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { parsePhoneNumberFromString } from "libphonenumber-js";

@Component({
  filters: {
    phone: function (phone: string) {
      if (!phone) return null;
      const parsed = parsePhoneNumberFromString(phone, "US");
      if (parsed) return parsed.formatNational();
      return phone;
    },
  },
})
export default class ProviderList extends Vue {
  @Prop(Array) readonly items!: Array<any>;
}
